// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".view-btn {\n  margin-right: 4px;\n  background: transparent;\n  border: 0;\n  font-size: 22px;\n  padding: 6px;\n  border-radius: 4px;\n  color: #acadaf;\n}\n.view-btn.active {\n  color: #c6262c;\n  background: #dadbdc;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
